"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state = {
    $currentLang: 'en-CA',
};
exports.default = state;
//# sourceMappingURL=state.js.map